import Card from "components/card";
import TableWithPaginationAndApi from "./TableWithPaginationAndApi";

const TicketsView = () => {
    return (
        <Card extra={"w-full h-full sm:overflow-auto px-6"}>
            <header className="relative flex items-center justify-between pt-4">
                <div className="text-xl font-bold text-navy-700 dark:text-white">
                    Tickets comprados
                </div>

            </header>
            <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
            <TableWithPaginationAndApi/>
            </div>
        </Card>
    )

}

export default TicketsView